import {
    DEMO_AUTH_SIGNUP_PATH,
    DEMO_AUTH_VERIFY_PATH,
    STANDALONE_JWT_STORAGE_KEY
} from "../config/ppAiConfig"

let inMemoryToken = null

export function getStandaloneToken() {
    if (typeof window === "undefined") return inMemoryToken
    try {
        const val = localStorage.getItem(STANDALONE_JWT_STORAGE_KEY)
        if (val) return val
    } catch { /* blocked */ }
    try {
        const val = sessionStorage.getItem(STANDALONE_JWT_STORAGE_KEY)
        if (val) return val
    } catch { /* blocked */ }
    return inMemoryToken
}

export function setStandaloneToken(token) {
    inMemoryToken = token || null
    if (typeof window === "undefined") return
    try {
        if (token) localStorage.setItem(STANDALONE_JWT_STORAGE_KEY, token)
        else localStorage.removeItem(STANDALONE_JWT_STORAGE_KEY)
    } catch { /* blocked */ }
    try {
        if (token) sessionStorage.setItem(STANDALONE_JWT_STORAGE_KEY, token)
        else sessionStorage.removeItem(STANDALONE_JWT_STORAGE_KEY)
    } catch { /* blocked */ }
}

export function clearStandaloneToken() {
    setStandaloneToken(null)
}

export async function demoSignup(email) {
    const url = DEMO_AUTH_SIGNUP_PATH
    const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() })
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
        const msg = data?.detail ?? data?.message ?? data?.error ?? res.statusText
        throw new Error(msg || "Demo-Signup fehlgeschlagen")
    }
    return data
}

export async function demoVerify(email, code) {
    const url = DEMO_AUTH_VERIFY_PATH
    const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), code: (code || "").trim() })
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
        const msg = data?.detail ?? data?.message ?? data?.error ?? res.statusText
        throw new Error(msg || "Verifizierung fehlgeschlagen")
    }
    const token = data?.token ?? data?.jwt
    if (!token) {
        throw new Error("Kein Token in der Antwort erhalten")
    }
    setStandaloneToken(token)
    return token
}
